const form = document.getElementById("form");
const sendButton = document.getElementById("js-send");
const spinElement = document.getElementById("js-spin");
const checkPointElements = document.querySelectorAll(".js-validate");
const telRegexFields = document.querySelectorAll(".js-tel-regex");

const CHECK_POINT = checkPointElements.length;

function switchSendButton(checkPoint) {
  if (checkPoint === 0) {
    sendButton.classList.add("is-checked");
  } else {
    sendButton.classList.remove("is-checked");
  }
}

function handleErrorMessage(
  changedElemId,
  validateElement,
  flag,
  message,
  isForceDisplayError,
) {
  const validateElementId = validateElement.id;
  const errorMessageElement = document.querySelector(
    `.${validateElementId}_error`,
  );

  if (flag) {
    if (validateElementId === changedElemId || isForceDisplayError) {
      validateElement.classList.remove("is-success");
      validateElement.classList.add("is-error");
      errorMessageElement.innerHTML = message;
    }
  } else {
    validateElement.classList.remove("is-error");
    validateElement.classList.add("is-success");
    errorMessageElement.innerHTML = "";
  }
}

function validate(changedElemId, isForceDisplayError) {
  let checkPoint = CHECK_POINT;

  checkPointElements.forEach((validateElement) => {
    let errorFlag = false;
    let errorMessage = null;
    const val = validateElement.value;

    switch (validateElement.id) {
      case "last_name":
        if (val.length === 0) {
          errorFlag = true;
          errorMessage = "お名前(姓)を入力してください";
        }
        break;

      case "first_name":
        if (val.length === 0) {
          errorFlag = true;
          errorMessage = "お名前(名)を入力してください";
        }
        break;

      case "tel":
        if (val.length > 0 && !/^\d{10,12}$/.test(val)) {
          errorFlag = true;
          errorMessage = "電話番号の形式が間違っています";
        } else if (val.length === 0) {
          errorFlag = true;
          errorMessage = "電話番号を入力してください";
        }
        break;

      case "email":
        if (!/.+@.+\..+/.test(val)) {
          errorFlag = true;
          errorMessage =
            "メールアドレスの形式が間違っています。正しいメールの形式になっているかご確認ください。";
        } else if (val.length === 0) {
          errorFlag = true;
          errorMessage = "メールアドレスを入力してください";
        }
        break;
    }

    if (!errorFlag) {
      checkPoint--;
    }

    handleErrorMessage(
      changedElemId,
      validateElement,
      errorFlag,
      errorMessage,
      isForceDisplayError,
    );
  });

  return checkPoint;
}

function toHankaku(str) {
  return str.replace(/[Ａ-Ｚａ-ｚ０-９]/g, (s) => {
    return String.fromCharCode(s.charCodeAt(0) - 0xfee0);
  });
}

window.addEventListener("DOMContentLoaded", () => {
  if (!form) {
    return;
  }

  telRegexFields.forEach((telField) => {
    telField.addEventListener("change", function () {
      this.value = toHankaku(this.value);
      if (this.id === "tel") {
        this.value = this.value.replace(/-/g, "");
      }
    });
  });

  checkPointElements.forEach((inputField) => {
    inputField.addEventListener("change", function (event) {
      if (event.isTrusted === false) {
        return;
      }
      const changedElemId = this.id;
      const checkPoint = validate(changedElemId, false);
      switchSendButton(checkPoint);
    });
  });

  sendButton.addEventListener("click", function (e) {
    const point = validate(null, true);
    if (point === 0) {
      spinElement.classList.add("is-show");
    } else {
      alert(`${point}つの項目が正しく記入されていません。`);
      e.preventDefault();
    }
  });

  const initialPoint = validate(null, false);
  switchSendButton(initialPoint);
});
